// @flow
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';
import { DateFormats, defaultProfileColumnsConfig } from 'UI/constants/defaults';
import { KEYWORDS_COLUMN } from 'UI/constants/sharedColumns';

export const CandidateProfileJobOrderColumns = [
  {
    name: 'id',
    options: {
      display: 'excluded'
    }
  },
  {
    name: 'title',
    label: 'Title',
    options: {
      display: true,
      sort: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.JobOrderProfile,
          idKey: 'id',
          textKey: 'title'
        }
      }
    }
  },
  {
    name: 'company_name',
    label: 'Company',
    options: {
      display: true,
      sort: true,
      renderer: {
        id: 'linkBuilder',
        config: {
          route: EntityRoutes.CompanyProfile,
          idKey: 'id',
          textKey: 'name'
        }
      }
    }
  },
  {
    name: 'position',
    label: strings.shared.fields.jobFunction,
    options: {
      ...defaultProfileColumnsConfig,
      renderer: {
        id: 'custom',
        config: {
          customValue: 'title'
        }
      }
    }
  },
  {
    name: 'specialty.industry.title',
    label: 'Industry',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'default'
    }
  },
  {
    name: 'specialty.title',
    label: 'Specialty',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'default'
    }
  },
  {
    name: 'whiteSheet',
    label: 'Compensation Range',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'compensationRange'
    }
  },
  {
    name: 'address',
    label: 'Location',
    options: {
      ...defaultProfileColumnsConfig,
      renderer: 'location'
    }
  },
  {
    name: 'created_at',
    label: 'Creation Date',
    options: {
      sort: true,
      renderer: 'date'
    }
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      display: false,
      sort: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          labelKey: 'title',
          baseClass: 'chip-candidate-status',
          variant: 'outlined'
        }
      }
    }
  },
  {
    name: 'whiteSheet.jobOrderType',
    label: 'Type',
    options: {
      display: false,
      sort: true,
      renderer: {
        id: 'fastChipBuilder',
        config: {
          baseClass: 'chip-candidate-type',
          labelKey: 'title'
        }
      }
    }
  },
  {
    name: 'last_activity_date',
    label: 'Last Activity on',
    options: {
      display: false,
      sort: true,
      renderer: {
        id: 'dateBuilder',
        config: {
          format: DateFormats.SimpleDateTime
        }
      }
    }
  },
  {
    name: 'vRecruiter.user_name',
    label: 'Recruiter',
    options: {
      sort: true,
      display: false,
      renderer: 'default'
    }
  },
  {
    name: 'lastActivityLog.recruiter',
    label: 'Last Activity by',
    options: {
      sort: false,
      renderer: 'default'
    }
  },
  {
    name: 'lastActivityLog.title',
    label: 'Last Activity',
    options: {
      sort: false,
      renderer: 'default'
    }
  },
  {
    ...KEYWORDS_COLUMN,
    name: 'keywordTags'
  }
];

export const VirtualProps = [
  {
    propName: 'title',
    attributes: ['title', 'id']
  }
];
